<template>
  <div class="main-content assets-content">
    <div class="main-element">
      <DropdownComponent
        :optionItems="setOptionValues('3D model')"
        :selectValue="getValue(product.modelFileName)"
        :isSearch="true"
        :isClearField="true"
        @changeValue="(value) => setPropertyValue(value, 'modelFileName')"
        fieldName="3D model" />
      <DropdownComponent
        :optionItems="setOptionValues('Image')"
        :selectValue="getValue(product.landscapeImagePath)"
        :isSearch="true"
        :isClearField="true"
        @changeValue="(value) => setPropertyValue(value, 'landscapeImagePath')"
        fieldName="Image" />
      <DropdownComponent
        :optionItems="setOptionValues('Datasheet')"
        :selectValue="getValue(product.dataSheetFilePath)"
        :isSearch="true"
        :isClearField="true"
        @changeValue="(value) => setPropertyValue(value, 'dataSheetFilePath')"
        fieldName="Datashet" />
      <DropdownComponent
        :optionItems="setOptionValues('Colorcode')"
        :selectValue="getValue(product.colorCodeImagePath)"
        :isSearch="true"
        :isClearField="true"
        @changeValue="(value) => setPropertyValue(value, 'colorCodeImagePath')"
        fieldName="Colorcode" />
    </div>
    <div class="main-element">
      <DropdownComponent
        :optionItems="setOptionValues('Ortho')"
        :selectValue="getValue(product.orthoPath)"
        :isSearch="true"
        :isClearField="true"
        @changeValue="(value) => setPropertyValue(value, 'orthoPath')"
        fieldName="Ortho" />
      <DropdownComponent
        :optionItems="setOptionValues('Video')"
        :selectValue="getValue(product.video.fileName)"
        :isSearch="true"
        :isClearField="true"
        @changeValue="(value) => setPropertyValue(value, 'video')"
        fieldName="Video" />
      <div class="kaltura-content">
        <TextComponent fieldName="Kaltura file ID" v-model="product.video.entryId" />
      </div>
      <div class="slide-element">
        <MultiselectComponent
          :optionItems="setOptionValues('Slides')"
          :selectedValue="slidesName"
          fieldName="Slides"
          @changeValue="setSlides" />
      </div>
    </div>
  </div>
</template>

<script>
import DropdownComponent from '../base.component/DropdownComponent.vue';
import AssetsService from '@/services/assetsServices/assetsService';
import MultiselectComponent from '../base.component/MultiselectComponent.vue';
import TextComponent from '../base.component/TextComponent.vue';
import { ASSET_TYPES } from '@/constants/assets';

export default {
  components: {
    DropdownComponent,
    MultiselectComponent,
    TextComponent
  },

  data() {
    return {
      slidesName: []
    }
  },

  props: {
    product: {
      type: Object,
      default: {},
    },
  },

  created() {
    this.slidesName = AssetsService.getProductSlidesName(this.product);

    if (this.product.video === null) {
      this.product.video = {};
    }
  },

  methods: {
    setOptionValues(assetType) {
      return AssetsService.getAssets()
        .filter((asset) => asset.type === assetType)
        .map((asset) => asset.fileId);
    },

    getValue(assetValue) {
      const currentValue = AssetsService.getAssets()
        .map((asset) => {
          return {
            path: asset.path,
            name: asset.fileId,
          };
        })
        .find((asset) => asset.path === assetValue);

      return currentValue?.name ?? '';
    },

    setSlides(slides) {
      this.product.slides = [];
      AssetsService.getAssets().forEach(asset => {
        if(slides.includes(asset.fileId)) {
          this.product.slides.push(asset.path)
        }
      })
    },

    setPropertyValue(value, prop) {
      if (value != '') {
        AssetsService.getAssets()
        .filter(asset => asset.fileId === value.trim())
        .forEach((asset) => {
          if (asset.type === ASSET_TYPES.VIDEO) {
            this.product[prop] = {
              fileName: asset.path
            }
          } else {
            this.product[prop] = asset.path;
          }
        });
      } else {
        this.product[prop] = prop === ASSET_TYPES.VIDEO.toLowerCase() ? {} : value;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.main-content {
  display: flex;
  max-width: 87vw !important;
}

.main-element {
  width: -webkit-fill-available;
}

.with-icon {
  min-width: -webkit-fill-available;
}

.kaltura-content {
  padding: 2rem;
  padding-left: 2.5rem;
  padding-right: 1.5rem;
}

.slide-element {
  padding-left: 0.5rem;
}

.assets-content {
  padding-top: 0;
  height: 75vh;
}
</style>